import { Injectable } from "@angular/core";
import { AuthSelector } from "@obg/ngx.core";

import { CommonState } from "../../state";

@Injectable({
	providedIn: "root",
})
export class CookieConsentSelector {
	shouldAskConsent() {
		return (state: CommonState): boolean =>
			state.cookieConsent.isEnabled &&
			state.cookieConsent.isConsentGiven === false &&
			!AuthSelector.isAuthenticated(state);
	}

	isAccepted() {
		return (state: CommonState): boolean => state.cookieConsent.isAccepted;
	}

	/**
	 * The selector will emit:
	 * - `undefined` when it is not yet known if the consent is given or not (cookie is not read yet)
	 * - `true` if the customer has given consent
	 * - `false` if the customer has not given consent
	 */
	isConsentGiven() {
		return (state: CommonState): boolean | undefined => state.cookieConsent.isConsentGiven;
	}
}
